"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.createStore('messageOption', {
    soundNotify: null,
    emailToastNotify: null,
    emptyDeletedItemsOnLogOut: null,
})();
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-option/lib/store/store.js
// module id = 3066
// module chunks = 2